export const IconArrow = ({ height = 12,width = 7,color = 'black',strokeWidth = '1.5' }) => {
  return (
    <svg width={width} height={height} viewBox='0 0 7 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M1 1L6 6L1 11' stroke={color} strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
    </svg>
  )
}
